import { useCallback, useEffect, useRef } from "react";
import { isSameValueAsInitialValue, omit } from "utils/helpers";

const AutoSave = ({ delay = 300, formik, skipInitValueCompare }) => {
	const { values, errors, initialValues, submitForm } = formik;

	// ref hooks
	const didMountRef = useRef(null);

	// event handlers
	const onFormSubmit = useCallback(async () => {
		if (!didMountRef?.current) {
			didMountRef.current = true;
			return;
		}
		const v = omit(values, Object.keys(errors));
		if (
			submitForm &&
			(!isSameValueAsInitialValue(v, initialValues) ||
				(isSameValueAsInitialValue(v, initialValues) && skipInitValueCompare))
		)
			submitForm(v);
	}, [values, errors, submitForm, initialValues, skipInitValueCompare]);

	// effect hooks
	useEffect(() => {
		const timer = setTimeout(() => onFormSubmit(), delay);
		return () => clearTimeout(timer);
	}, [values, errors, delay, onFormSubmit]);

	return null;
};

export default AutoSave;
